<template>
  <div class="duolian-container bg-white">
    <p class="title">愿景使命驱动、聚焦经营、组织力提升、模式闭环</p>
    <div class="content">
      <div class="center">待办</div>
      <div class="center">奖惩</div>
      <div class="center">重要数据</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'duolianHome'
}
</script>

<style lang="less" scoped>
.title {
  font-family: youshe;
  padding-top: 112px;
  margin-left: 145px;
  color: #1d2129;
  font-size: 30px;
  letter-spacing: 4px;
}
.content {
  margin-top: 62px;
  margin-left: 145px;
  div {
    float: left;
    width: 98px;
    height: 98px;
    border-radius: 2px;
    background-color: #326fff;
    font-family: youshe;
    font-size: 28px;
    color: #fff;
    letter-spacing: 4px;
    margin-right: 30px;
    padding: 0 10px;
    text-align: center;
    line-height: 1;
  }
}
</style>
